import { user } from '@/lib/AuthenticatorPlugin.ts'

export default () => {
  return !!(!user.value.user_has_password && user.value.legacy_user)
}
